import Message from './Message'
import classNames from '@/utils/classNames'
import type { ReactNode, Ref, UIEventHandler } from 'react'
import type { ScrollBarRef } from '../types'
import type { MessageProps } from './Message'

type List = MessageProps & { fresh?: boolean; streaming?: boolean; error?: boolean }

export type MessageListProps = {
    list: List[]
    typing?:
        | {
              id: string
              name: string
              avatarImageUrl?: string
          }
        | false
    customRenderer?: (message: List, index: number) => string | ReactNode
    customAction?: (message: List, index: number) => string | ReactNode
    bubbleClass?: string
    messageListClass?: string
    onScroll?: UIEventHandler<HTMLDivElement>
    ref?: Ref<ScrollBarRef>
}

const MessageList = (props: MessageListProps) => {
    const {
        list = [],
        typing = false,
        customRenderer,
        customAction,
        messageListClass,
        bubbleClass,
        onScroll,
        ref,
    } = props

    return (
        <div
            ref={ref}
            className={classNames(
                'rda-vscroll h-full max-w-full overflow-y-auto',
                messageListClass,
            )}
            onScroll={onScroll}
        >
            <div className="flex flex-col gap-6 px-4 py-4">
                {list.map((message, index) => (
                    <Message
                        key={message.id}
                        bubbleClass={bubbleClass}
                        {...message}
                        {...(customRenderer
                            ? {
                                  customRenderer: () =>
                                      customRenderer(message, index),
                              }
                            : {})}
                        {...(customAction
                            ? {
                                  customAction: () =>
                                      customAction(message, index),
                              }
                            : {})}
                    />
                ))}
                {typing && (
                    <Message
                        id={typing.name + 'typing'}
                        sender={typing}
                        type="regular"
                        contextFiles={[]}
                        bubbleClass={bubbleClass}
                        content={
                            <span className="flex items-center gap-1.5 py-0.5">
                                <span className="size-1.5 rounded-full bg-[var(--rda-accent)] opacity-70 motion-safe:animate-[bounce_1s_ease-in-out_infinite]" />
                                <span className="size-1.5 rounded-full bg-[var(--rda-accent)] opacity-70 motion-safe:animate-[bounce_1s_ease-in-out_0.15s_infinite]" />
                                <span className="size-1.5 rounded-full bg-[var(--rda-accent)] opacity-70 motion-safe:animate-[bounce_1s_ease-in-out_0.3s_infinite]" />
                            </span>
                        }
                    />
                )}
            </div>
        </div>
    )
}

export default MessageList
